import { lazy } from "react";
import PaymentSuccess from "../pages/payments/success";
import { redirectionRoutes } from "./redirectionRoutes";
const Main = lazy(() => import("../components/layout/main"));
const Dashboard = lazy(() => import("../pages/dashboard"));
const Profile = lazy(() => import("../pages/profile"));
const ChangePassword = lazy(() => import("../pages/change-password"));
const RolesAndPermission = lazy(() => import("../pages/roles-permission"));
const AddEditRoles = lazy(() => import("../pages/roles-permission/add-edit"));
const UsersList = lazy(() => import("../pages/users"));
const AddEditUser = lazy(() => import("../pages/users/add-edit"));
const SitesList = lazy(() => import("../pages/sites"));
const ScanFormTabs = lazy(() => import("../pages/scan"));
const Subscription = lazy(() => import("../pages/subscription"));
const PaymentList = lazy(() => import("../pages/payments"));
const ScanHistoryList = lazy(() => import("../pages/scan-history"));
const ScanHistoryView = lazy(() => import("../pages/scan-history/view"));
const Branding = lazy(() => import("../pages/branding"));
const Help = lazy(() => import("../pages/help"));
const RequestLoa = lazy(() => import("../pages/request-loa"));
const AccountSettings = lazy(() => import("../pages/account-settings"));
const ApiIntegration = lazy(() => import("../pages/api-integration"))

const protectRoutes = [
    {
        path: "",
        element: <Main />,
        children: [
            {
                path: redirectionRoutes.dashboard.path,
                index: true,
                element: <Dashboard />,
            },
            {
                path: redirectionRoutes.profile.path,
                element: <Profile />,
            },
            {
                path: redirectionRoutes.changePassword.path,
                element: <ChangePassword />,
            },
            {
                path: redirectionRoutes.roles.path,
                children: [
                    { path: "", index: true, element: <RolesAndPermission /> },
                    { path: redirectionRoutes.commonAdd.path, element: <AddEditRoles /> },
                    { path: redirectionRoutes.commonEdit.path, element: <AddEditRoles /> },
                ],
            },
            {
                path: redirectionRoutes.users.path,
                children: [
                    { path: "", index: true, element: <UsersList /> },
                    { path: redirectionRoutes.commonAdd.path, element: <AddEditUser /> },
                    { path: redirectionRoutes.commonEdit.path, element: <AddEditUser /> },
                ],
            },
            {
                path: redirectionRoutes.sites.path,
                element: <SitesList />,
            },
            {
                path: redirectionRoutes.scan.path,
                children: [
                    { path: "", index: true, element: <ScanFormTabs /> },
                ],
            },
            {
                path: redirectionRoutes.subscription.path,
                element: <Subscription />,
            },
            {
                path: redirectionRoutes.payment.path,
                children: [
                    { path: "", index: true, element: <PaymentList /> },
                    { path: redirectionRoutes.paymentSuccess.path, element: <PaymentSuccess /> },
                ],
            },
            {
                path: redirectionRoutes.scanHistory.path,
                children: [
                    { path: "", index: true, element: <ScanHistoryList /> },
                    { path: redirectionRoutes.commonView.path, element: <ScanHistoryView /> },
                ],
            },
            {
                path: redirectionRoutes.branding.path,
                element: <Branding />,
            },
            {
                path: redirectionRoutes.help.path,
                element: <Help />,
            },
            {
                path: redirectionRoutes.requestLoa.path,
                element: <RequestLoa />,
            },
            {
                path: redirectionRoutes.accountSettings.path,
                element: <AccountSettings />,
            },
            {
                path: redirectionRoutes.apiIntegration.path,
                element: <ApiIntegration />,
            },
        ],
    },
];

export default protectRoutes;
